import styles from './Brand.module.css';

type BrandProps = {
  size?: 'default' | 'hero';
};

export function Brand({ size = 'default' }: BrandProps) {
  return (
    <div className={size === 'hero' ? styles.hero : styles.brand}>
      <span className={styles.brandMark}>
        <img src="/brand/trove-keyhole.png" alt="" />
      </span>
      <span data-brand-label>Trove</span>
    </div>
  );
}
